import { render, staticRenderFns } from "./EditHotel.vue?vue&type=template&id=eec22834"
import script from "./EditHotel.vue?vue&type=script&lang=js"
export * from "./EditHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports